import { Col, Row } from 'antd';
import React from 'react';

const HeureView = ({value}) => {


    return (
          <div>
            <Row>
                <Col span={16}> <span style={{color:"#5F6368", fontSize:13, fontFamily:" Roboto, Arial, sans-serif"}}>Heure</span></Col> 
                <Col span={16} style={{marginTop:8}}> <span style={{fontSize:16, fontFamily:" Roboto, Arial, sans-serif", letterSpacing:2}}>{value}</span></Col>
            </Row>
        </div>
    );
};

export default HeureView;